// GENERATE BY ./scripts/generate.ts
// DON NOT EDIT IT MANUALLY
import * as React from 'react';
import MedicineBoxOutlinedSvg from "@fishx/icons-svg/es/asn/MedicineBoxOutlined";
import FishxIcon from '../components/FishxIcon';

var MedicineBoxOutlined = function MedicineBoxOutlined(props, ref) {
  return React.createElement(FishxIcon, Object.assign({}, props, {
    ref: ref,
    icon: MedicineBoxOutlinedSvg
  }));
};

MedicineBoxOutlined.displayName = 'MedicineBoxOutlined';
export default React.forwardRef(MedicineBoxOutlined);


//////////////////
// WEBPACK FOOTER
// ./node_modules/@fishx/icons/es/icons/MedicineBoxOutlined.js
// module id = 3100
// module chunks = 0